import To from 'await-to-js'
import encodeUrl from 'encodeurl'
import qs from 'qs'
import { wizStandardInstance } from '@/services/instance'
import Callback from './callback'

const ApiMixinClashManagement = {
  async ApiClashList(
    arg = {
      method: 'list',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'query':
        console.log(`${arg.params}23423423423424`)
        let dateTime = ''
        if (arg.params.dateType) {
          dateTime = `${arg.params.dateType}=${arg.params.dateStart}~${arg.params.dateEnd}`
        } else {
          dateTime = ''
        }
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/ClashReport/clash/?pageNo=${arg.params.pageNo}&pageSize=${arg.params.pageSize}&clashReportNumber=${arg.params.clashReportNumber}&area=${arg.params.area}&${dateTime}&drawingCode=${arg.params.drawingCode}&tagCode=${arg.params.tagCode}&approver=${arg.params.approver}&discipline=${arg.params.discipline}&constructionStatus=${arg.params.constructionStatus}&flowStatus=${arg.params.flowStatus}&siteId=${arg.params.siteId}&disciplinename=${arg.params.disciplinename}`
          )
        )
        break
      case 'create':
        ;[err, res] = await To(wizStandardInstance.post('/api/ClashReport/clash', arg.params))
        break
      case 'delete':
        ;[err, res] = await To(
          wizStandardInstance.delete(`/api/ClashReport/clash/${arg.params.id}`)
        )
        break
      case 'edit':
        break
      case 'update':
        ;[err, res] = await To(wizStandardInstance.patch('/api/ClashReport/clash', arg.params))
        break
      case 'add':
        break
      case 'detail':
        ;[err, res] = await To(wizStandardInstance.get(`/api/ClashReport/clash/${arg.params.id}`))
        break
      case 'handle':
        ;[err, res] = await To(
          wizStandardInstance.post(
            `/api/ClashReport/clash_check/${arg.params.siteId}`,
            arg.formData
          )
        )
        break
      case 'rename':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/ClashReport/clash_rename', arg.params)
        )
        break
      case 'tagCodeList':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/BaseData/tag/?code=${arg.params.code}&pageno=${arg.params.pageno}&pagesize=${arg.params.pagesize}&status=${arg.params.status}`
          )
        )
        break
      case 'tagNameList':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/BaseData/tag/?name=${arg.params.name}&pageno=${arg.params.pageno}&pagesize=${arg.params.pagesize}&status=${arg.params.status}`
          )
        )
        break
      case 'flowBindAttachment':
        ;[err, res] = await To(
          wizStandardInstance.get('/api/clashReport/clash_attachment', arg.params)
        )
        break
      case 'download':
        ;[err, res] = await To(
          wizStandardInstance.post('/api/clashReport/clash_download', arg.params)
        )
        break
      default:
        ;[err, res] = await To(
          wizStandardInstance.patch(
            `/api/PartNumberCost/main/${arg.params.modelId}/${arg.params.area}`,
            arg.params.list
          )
        )
        break
    }
    return Callback.globalCB(err, res, arg.extra)
  },
  async ApiClashReport(
    arg = {
      method: '',
      params: {},
      formData: {},
    }
  ) {
    let [err, res] = [null, null]
    switch (arg.method) {
      case 'statistic':
        ;[err, res] = await To(
          wizStandardInstance.get(
            encodeUrl(
              'http://mockserver01.wiz.com:7300/mock/5c78ec3974acbb0020b473bb/plant/clash/clash-report#!method=get'
            )
          )
        )
        break

      case 'query':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/ClashReport/clash-report/?siteId=${arg.params.siteId}&createdtime=${arg.params.dateStart}~${arg.params.dateEnd}`
          )
        )
        break
      case 'save':
        ;[err, res] = await To(wizStandardInstance.post('/api/ClashReport/clash', arg.params))
        break
      case 'findIndex':
        ;[err, res] = await To(
          wizStandardInstance.get(
            `/api/ClashReport/clash_report_id_location?${qs.stringify(arg.params)}`
          )
        )
        break
      default:
        ;[err, res] = await To(
          wizStandardInstance.get(
            'http://mockserver01.wiz.com:7300/mock/5c78ec3974acbb0020b473bb/plant/clash/clash-report#!method=get'
          )
        )
    }
    return Callback.globalCB(err, res, arg.extra)
  },
}

export default {
  methods: ApiMixinClashManagement,
}
